import { render, staticRenderFns } from "./quick.vue?vue&type=template&id=1cd28e90"
import script from "./quick.vue?vue&type=script&lang=js"
export * from "./quick.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports